// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\DashboardStatsExportBookingsResponse

export type DashboardStatsExportBookingsApiResponse = {
	success: boolean;
	message: string;
};

export type DashboardStatsExportBookings = {
	success: boolean;
	message: string;
};

export function hydrateDashboardStatsExportBookings(data: DashboardStatsExportBookingsApiResponse): DashboardStatsExportBookings {
	return { ...data };
}